import * as React from 'react'
import { cn } from 'src/lib/utils'

export interface FormFieldErrorProps {
  children?: React.ReactNode
  className?: string
}

export const FormFieldError = ({ children, className }: FormFieldErrorProps): React.ReactElement | null => {
  if (!children) return null

  return <p className={cn('text-xs font-roboto-condensed font-semibold text-error-2 tracking-[0.5px]', className)}>{children}</p>
}
